import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import React, {Component} from "react";
import {List} from "antd";
import CheckboxServiceItem from "./CheckboxServiceItem";
import {TIRE_REPLACEMENT, TIRES_EXCHANGE} from "../../definition/business";
import TireExchange from "./TireExchange";
import TireReplacement from "./TireReplacement";
import {SelectedService} from "../../definition/journeyModel";
import {isoDurationToMinutes} from "../../definition/helper";

class MainServices extends Component {

  onCheckboxChange = (checked, item)=> {

    if (checked === true) {// unchecking the checkbox
      this.props.addService({
        selectedService:new SelectedService(
          item.name,
          item.title,
          isoDurationToMinutes(item.duration), //
          item.duration,
          item.price,
          item.description,
          item.moreInfo)
      });
    } else {
      this.props.removeService({name:item.name});
    }

  }

  hasOption = name => !!this.props.selectedOptions.find(o => o.id === name);

  render() {
    const {mainServices, otherServices} = this.props;
    return <React.Fragment>
      <div style={{ paddingLeft: 20 }}>
        {mainServices && mainServices.length > 0 && <List
          itemLayout="horizontal"
          dataSource={mainServices}
          renderItem={item=><li style={{padding:'12px 0'}}><CheckboxServiceItem onChange={this.onCheckboxChange} checked={this.hasOption(item.name)} item={item}/></li>}
        />
        }

        {otherServices && otherServices.length > 0 && <List
          itemLayout="horizontal"
          dataSource={otherServices}
          renderItem={item=><li style={{padding:'12px 0'}}>
            <CheckboxServiceItem onChange={this.onCheckboxChange} checked={this.hasOption(item.name)} item={item}/>
            <div style={{flexBasis: '100%',height: 0}}></div>
            {item.name === TIRES_EXCHANGE && this.hasOption(item.name) && <TireExchange/>}
            {item.name === TIRE_REPLACEMENT && this.hasOption(item.name) && <TireReplacement style={{display:'block'}}/>}
          </li>}
        />
        }
      </div>
    </React.Fragment>
  }
}


const mapDispatchToProps = dispatch => ({
  addService: params => dispatch({ type: 'SAVE.ADD_SERVICE', params }),
  removeService: params => dispatch({ type: 'SAVE.REMOVE_SERVICE', params }),
});

const mapStateToProps = state => ({
  mainServices: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.mainServices,
  otherServices: state.customerPreJourneyInfo.preJourneyInfo && state.customerPreJourneyInfo.preJourneyInfo.services && state.customerPreJourneyInfo.preJourneyInfo.services.otherServices,
  selectedOptions: state.createAppointmentRequest.selectedOptions,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MainServices)
);
